import { keys } from "./keys.js";
function getTranslationKey(validationError, name) {
    if (null != validationError.contexts) for (const context of Object.values(validationError.contexts)){
        const typedContext = context;
        if (null != typedContext.translationKey && '' !== typedContext.translationKey) return typedContext.translationKey;
    }
    return `validation${name[0].toUpperCase()}${name.slice(1)}`;
}
function createValidationPointersFromClassValidator(validationErrors) {
    const result = {};
    for (const validationError of validationErrors){
        const { constraints, property, value, contexts = {} } = validationError;
        const fieldName = property;
        if (void 0 === result[fieldName]) result[fieldName] = [];
        const validationMessages = result[fieldName];
        let errors = [];
        if (null == value && (constraints?.isDefined != null || constraints?.isNotEmpty != null)) errors = [
            {
                translationKey: getTranslationKey(validationError, 'isDefined'),
                message: constraints.isDefined ?? constraints.isNotEmpty,
                arguments: {}
            }
        ];
        else if (null != constraints) errors = Object.keys(constraints).map((key)=>({
                translationKey: getTranslationKey(validationError, key),
                message: constraints[key],
                arguments: {
                    ...contexts[key],
                    value
                }
            }));
        if (void 0 !== validationMessages) validationMessages.push(...errors);
    }
    return result;
}
function getValidationPointerMessages(fieldName, validationPointers) {
    const validationMessages = validationPointers[fieldName];
    if (void 0 !== validationMessages) return validationMessages;
    return [];
}
function setValidationPointerMessages(fieldName, messages, validationPointers) {
    validationPointers[fieldName] = messages;
}
function addValidationPointerMessages(fieldName, messages, validationPointers) {
    const validationMessages = validationPointers[fieldName];
    if (void 0 === validationMessages) validationPointers[fieldName] = [
        ...messages
    ];
    else validationMessages.push(...messages);
}
function mergeValidationPointers(...validationPointers) {
    const result = {};
    for (const validationPointer of validationPointers)for (const fieldName of keys(validationPointer))result[fieldName] = [
        ...getValidationPointerMessages(fieldName, result),
        ...getValidationPointerMessages(fieldName, validationPointer)
    ];
    return result;
}
export { addValidationPointerMessages, createValidationPointersFromClassValidator, getValidationPointerMessages, mergeValidationPointers, setValidationPointerMessages };
